import { useRef } from 'react';
import {
  useUploadComunicadoMedia,
  useDeleteComunicadoMedia,
} from './use-comunicado-media';
import { MAX_MEDIA } from '../components/composer-media-thumb';

type Args = {
  comunicadoId: string | undefined;
  files: string[];
  onChanged: () => void;
};

function useFileChange(args: {
  comunicadoId: string | undefined;
  filesCount: number;
  onChanged: () => void;
}) {
  const upload = useUploadComunicadoMedia();
  const onPick = (chosen: globalThis.File[]): void => {
    if (!args.comunicadoId) return;
    const remaining = MAX_MEDIA - args.filesCount;
    if (remaining <= 0) return;
    upload.mutate(
      { id: args.comunicadoId, files: chosen.slice(0, remaining) },
      { onSuccess: args.onChanged }
    );
  };
  return { onPick, pending: upload.isPending };
}

export function useComposerMedia(args: Args) {
  const inputRef = useRef<HTMLInputElement>(null);
  const del = useDeleteComunicadoMedia();
  const { onPick, pending } = useFileChange({
    comunicadoId: args.comunicadoId,
    filesCount: args.files.length,
    onChanged: args.onChanged,
  });
  const disabled =
    !args.comunicadoId || args.files.length >= MAX_MEDIA || pending;
  const onRemove = (f: string): void => {
    if (!args.comunicadoId) return;
    del.mutate(
      { id: args.comunicadoId, filename: f },
      { onSuccess: args.onChanged }
    );
  };
  return { inputRef, onPick, pending, disabled, onRemove };
}
